import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'projects/app-shared/src/public-api';
import { EcommerceGenericoService, PedidosMmaxEccomerce, TurnosRetiroEccomerce, Usuario } from 'projects/ecommerce-generico/src/public-api';
import { MarianomGeneral } from '../../marianom-general.service';

@Component({
  selector: 'confirmar-checkout-modal',
  templateUrl: './confirmar-checkout-modal.component.html',
  styleUrls: ['./confirmar-checkout-modal.component.scss']
})

export class ConfirmarCheckoutModalComponent implements OnInit {
  constructor(private serv: MarianomGeneral, private genServ : EcommerceGenericoService, private router: ActivatedRoute, private modal: ModalService) {
    this.genServ.getPagoDiferido().subscribe(data => {
      this.pagoDiferido = data;
    })
    this.textoCerrarPedido = this.genServ.getTextoCerrarPedido() || this.textoCerrarPedido;
    this.checkForm = false;
  }

  ngOnInit(): void {
  }

  cerrarPedido() {
    this.turnoselecionado = this.serv.ultimoTurno();
    this.serv.setTurno(this.turnoselecionado);
    if (this.observacion) {
      this.genServ.setObservacion(this.observacion)
    }

    this.genServ.agregarItemEnvio();

    this.modal.close('confirmar-checkout-modal-1');

    this.serv.prayandpaid().subscribe(data => {
      let pedido = data['pedido'] as PedidosMmaxEccomerce;
      this.genServ.guardarpedido(pedido);
      this.genServ.setDatosEnvio(undefined)
      //console.log("PAGODIFERIDO", this.pagoDiferido);
      if (pedido.estado === "Cerrado") {
        alert('✅ Pedido confirmado!');
      } else {
        alert('⚠️ Pedido recibido!');
      }

      if (this.pagoDiferido === "E") {
        this.serv.navigator.endline(this.router);
        this.genServ.resetEccomerce();
      }
      else {
        this.serv.navigator.cierreCheckout(this.router);
      }
    });
  }

  cancelar() {
    this.modal.close('confirmar-checkout-modal-1')
  }

  observacion: string;
  turnoselecionado: TurnosRetiroEccomerce;
  envioHabilitado: string;
  textoCerrarPedido = "Esta acción finalizará el pedido."
                      "<br >Una vez que confirme, no podrá agregar más productos ni modificar los turnos para este pedido. "
                      "<br >¿Desea continuar con el cierre del pedido?";
  pagoDiferido: string;
  checkForm: boolean;
}
